import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=ad9466e4"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=ad9466e4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad9466e4')) {
      api.createRecord('ad9466e4', component.options)
    } else {
      api.reload('ad9466e4', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=ad9466e4", function () {
      api.rerender('ad9466e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/ResetPassword.vue"
export default component.exports